import { twMerge } from "@/utils/twMerge";

type AnimateProps = {
  animate?: boolean;
};

/**
 * @example
 * <Skeleton.Root>
 *   <Skeleton.Text className="w-[200px]" />
 *   <Skeleton.Block className="h-[50px]" />
 *   <Skeleton.Block className="h-[50px] mt-2" />
 * </Skeleton.Root>
 */
function SkeletonRoot({ className, ...rest }: React.ComponentProps<"div">) {
  return <div aria-busy {...rest} className={twMerge("w-full", className)} />;
}

/**
 * Basic skeleton block.
 * @example
 * <Skeleton.Block className="h-[50px]" />
 */
function SkeletonBlock({
  className,
  animate = true,
  ...rest
}: React.ComponentProps<"div"> & AnimateProps) {
  return <div className={twMerge(animate && "skeleton-shimmer", className)} {...rest} />;
}

/**
 * Creates a block that is of a height that equals to current line height.
 *
 * @example
 * <div className="text-size-15">
 *   ...
 *   <Skeleton.Text className="w-[200px]" />
 *   ...
 * </div>
 */
function SkeletonText({
  className,
  animate = true,
  ...rest
}: React.ComponentProps<"div"> & AnimateProps) {
  return (
    <div
      className={twMerge(
        "select-none inline-block bg-gray-100 dark:bg-gray-800",
        animate && "skeleton-shimmer",
        className,
      )}
      {...rest}
    >
      {"\u2000"}
    </div>
  );
}

export { SkeletonBlock as Block, SkeletonRoot as Root, SkeletonText as Text };
